/**
 * Driver preference profile for tire recommendations (finder + results).
 */
(function (global) {
  var STORAGE_KEY = "specr_tire_profile";
  var CONFIG_PROXY = "/apps/specr/api/tire-recommendation-config";

  var GOALS = [
    { id: "winter_safety", label: "Winter safety" },
    { id: "all_season", label: "All-season balance" },
    { id: "performance", label: "Performance" },
    { id: "value", label: "Best value" },
    { id: "longevity", label: "Long tread life" },
  ];

  var DRIVING = [
    { id: "city", label: "City" },
    { id: "highway", label: "Highway" },
    { id: "mixed", label: "Mixed" },
    { id: "light_trail", label: "Light trail" },
  ];

  var PRIORITIES = [
    { id: "grip", label: "Grip" },
    { id: "quiet", label: "Quiet ride" },
    { id: "mileage", label: "Mileage" },
    { id: "price", label: "Lowest price" },
  ];

  var WIZARD_STEPS = [];
  var recommendationsEnabled = true;
  var configReady = false;
  var configReadyCallbacks = [];

  function rebuildWizardSteps() {
    WIZARD_STEPS = [
      { id: "goal", legend: "What matters most?", options: GOALS, name: "goal" },
      {
        id: "driving",
        legend: "How do you drive?",
        options: DRIVING,
        name: "driving",
        defaultId: DRIVING.some(function (o) {
          return o.id === "mixed";
        })
          ? "mixed"
          : DRIVING[0]
            ? DRIVING[0].id
            : "",
      },
      { id: "priority", legend: "Priority (optional)", options: PRIORITIES, name: "priority" },
    ];
  }

  rebuildWizardSteps();

  function whenConfigReady(cb) {
    if (typeof cb !== "function") return;
    if (configReady) {
      cb();
      return;
    }
    configReadyCallbacks.push(cb);
  }

  function flushConfigReadyCallbacks() {
    configReady = true;
    var pending = configReadyCallbacks.slice();
    configReadyCallbacks = [];
    pending.forEach(function (cb) {
      try {
        cb();
      } catch (e) {}
    });
  }

  function isRecommendationsEnabled() {
    return recommendationsEnabled;
  }

  function applyPortalConfig(data) {
    if (!data || data.error) return;
    if (typeof data.enabled === "boolean") {
      recommendationsEnabled = data.enabled;
    }
    var wo = data.wizardOptions;
    if (wo) {
      if (Array.isArray(wo.goals) && wo.goals.length) GOALS = wo.goals.slice();
      if (Array.isArray(wo.driving) && wo.driving.length) DRIVING = wo.driving.slice();
      if (Array.isArray(wo.priorities) && wo.priorities.length) PRIORITIES = wo.priorities.slice();
      rebuildWizardSteps();
    }
  }

  function refreshProfilePanelsAfterConfig() {
    document.querySelectorAll("#tr-profile-root").forEach(function (root) {
      delete root.dataset.profileInit;
      root.innerHTML = "";
      root.classList.remove("tr-profile");
    });
    bootProfilePanels();
  }

  function fetchPortalConfig() {
    fetch(CONFIG_PROXY, { method: "GET", headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (out) {
        if (out.ok && out.data) applyPortalConfig(out.data);
      })
      .catch(function () {})
      .finally(function () {
        refreshProfilePanelsAfterConfig();
        flushConfigReadyCallbacks();
      });
  }

  function readFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var goal = params.get("goal");
    if (!goal) return null;
    return {
      goal: goal,
      driving: params.get("driving") || "mixed",
      priority: params.get("priority") || "",
    };
  }

  function readFromStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function readProfile() {
    return readFromUrl() || readFromStorage() || null;
  }

  function writeProfile(profile) {
    if (!profile || !profile.goal) return;
    var data = {
      goal: profile.goal,
      driving: profile.driving || "mixed",
      priority: profile.priority || "",
      updatedAt: Date.now(),
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function clearProfile() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function appendProfileStateToQueryString(qs, profile) {
    if (!profile || !profile.goal) return qs || "";
    var params = new URLSearchParams((qs || "").replace(/^\?/, ""));
    params.set("goal", profile.goal);
    if (profile.driving) params.set("driving", profile.driving);
    if (profile.priority) params.set("priority", profile.priority);
    var s = params.toString();
    return s ? "?" + s : qs || "";
  }

  function syncChipGroupUi(container, name, selectedId) {
    if (!container) return;
    container.querySelectorAll('.tr-profile-chip[data-profile-name="' + name + '"]').forEach(function (btn) {
      var val = btn.getAttribute("data-profile-value");
      var active = !!selectedId && selectedId === val;
      btn.classList.toggle("tr-profile-chip--active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function mountWizardStep(container, stepDef, state, onSelect) {
    if (!container || !stepDef) return;
    container.innerHTML = "";
    var selectedId = state[stepDef.name];
    if (!selectedId && stepDef.defaultId) selectedId = stepDef.defaultId;
    renderChipGroup(container, stepDef.legend, stepDef.options, stepDef.name, selectedId, function (name, value) {
      var nextValue = value;
      if (name === "priority" && state[name] === value) {
        nextValue = "";
      }
      state[name] = nextValue;
      syncChipGroupUi(container, name, state[name]);
      if (onSelect) onSelect(name, state[name]);
    });
    var firstChip = container.querySelector(".tr-profile-chip");
    if (firstChip) firstChip.focus();
  }

  function appendProfileToSearchParams(params) {
    var profile = readProfile();
    if (!profile || !profile.goal) return params;
    params.set("goal", profile.goal);
    if (profile.driving) params.set("driving", profile.driving);
    if (profile.priority) params.set("priority", profile.priority);
    return params;
  }

  function appendProfileToQueryString(qs) {
    var profile = readProfile();
    if (!profile || !profile.goal) return qs || "";
    var prefix = qs && qs.indexOf("?") === 0 ? qs : qs ? "?" + qs.replace(/^\?/, "") : "";
    var params = new URLSearchParams(prefix.replace(/^\?/, ""));
    appendProfileToSearchParams(params);
    var s = params.toString();
    return s ? "?" + s : "";
  }

  function renderChipGroup(container, legend, options, name, selectedId, onSelect) {
    var fieldset = document.createElement("fieldset");
    fieldset.className = "tr-profile-group";
    var leg = document.createElement("legend");
    leg.className = "tr-profile-group__legend";
    leg.textContent = legend;
    fieldset.appendChild(leg);
    var row = document.createElement("div");
    row.className = "tr-profile-chips";
    row.setAttribute("role", "group");
    options.forEach(function (opt) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tr-profile-chip";
      btn.setAttribute("data-profile-name", name);
      btn.setAttribute("data-profile-value", opt.id);
      btn.setAttribute("aria-pressed", selectedId === opt.id ? "true" : "false");
      if (selectedId === opt.id) btn.classList.add("tr-profile-chip--active");
      btn.textContent = opt.label;
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        onSelect(name, opt.id);
      });
      row.appendChild(btn);
    });
    fieldset.appendChild(row);
    container.appendChild(fieldset);
  }

  function initProfilePanel(root, options) {
    if (!root) return null;
    var onChange = (options && options.onChange) || function () {};
    var stored = readProfile();
    var defaultDriving =
      DRIVING.some(function (o) {
        return o.id === "mixed";
      })
        ? "mixed"
        : DRIVING[0]
          ? DRIVING[0].id
          : "";
    var state = {
      goal: (stored && stored.goal) || "",
      driving: (stored && stored.driving) || defaultDriving,
      priority: (stored && stored.priority) || "",
    };

    root.innerHTML = "";
    root.classList.add("tr-profile");

    function syncUi() {
      root.querySelectorAll(".tr-profile-chip").forEach(function (btn) {
        var name = btn.getAttribute("data-profile-name");
        var val = btn.getAttribute("data-profile-value");
        var active = state[name] === val;
        btn.classList.toggle("tr-profile-chip--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function setField(name, value) {
      state[name] = value;
      if (state.goal) writeProfile(state);
      syncUi();
      onChange(state);
    }

    renderChipGroup(root, "What matters most?", GOALS, "goal", state.goal, setField);
    renderChipGroup(root, "How do you drive?", DRIVING, "driving", state.driving, setField);
    renderChipGroup(root, "Priority", PRIORITIES, "priority", state.priority, setField);

    return {
      getState: function () {
        return { goal: state.goal, driving: state.driving, priority: state.priority };
      },
      setState: function (next) {
        state.goal = next.goal || "";
        state.driving = next.driving || defaultDriving;
        state.priority = next.priority || "";
        if (state.goal) writeProfile(state);
        syncUi();
      },
    };
  }

  function bootProfilePanels() {
    document.querySelectorAll("#tr-profile-root").forEach(function (root) {
      if (root.dataset.profileInit === "1") return;
      root.dataset.profileInit = "1";
      initProfilePanel(root);
    });
  }

  global.SpecrTireProfile = {
    get GOALS() {
      return GOALS;
    },
    get DRIVING() {
      return DRIVING;
    },
    get PRIORITIES() {
      return PRIORITIES;
    },
    get WIZARD_STEPS() {
      return WIZARD_STEPS;
    },
    STORAGE_KEY: STORAGE_KEY,
    readProfile: readProfile,
    writeProfile: writeProfile,
    clearProfile: clearProfile,
    appendProfileToSearchParams: appendProfileToSearchParams,
    appendProfileToQueryString: appendProfileToQueryString,
    appendProfileStateToQueryString: appendProfileStateToQueryString,
    renderChipGroup: renderChipGroup,
    mountWizardStep: mountWizardStep,
    initProfilePanel: initProfilePanel,
    bootProfilePanels: bootProfilePanels,
    isRecommendationsEnabled: isRecommendationsEnabled,
    whenConfigReady: whenConfigReady,
  };

  if (typeof document !== "undefined") {
    fetchPortalConfig();
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootProfilePanels);
    } else {
      bootProfilePanels();
    }
  }
})(typeof window !== "undefined" ? window : this);
